import { useMutation } from "urql";

import { HandoverLimitRequestToOlDocument } from "../../../graphql/generated.ts";

export const useHandoverLimitRequestToOL = () =>
  useMutation(HandoverLimitRequestToOlDocument);
